export const environment = {
  production: true,
  coreApiUrl: 'https://ifenua.demo.ifenua.dev/api',
  envName: 'demo',
};
